// src/data/teamData.jsx
import ashmiImg from "../assets/images/team/ashmi.jpg"
import mehrdadImg from "../assets/images/team/Mehrdad-Rostami-4.png"
import mahdiImg from "../assets/images/team/mahdi-jalili.jpeg"
import avishekImg from "../assets/images/team/avishek.jpg"
import wolfgangImg from "../assets/images/team/woerndl-nov16-crop.jpg"
import alexImg from "../assets/images/team/alexander.png"
import mouradImg from "../assets/images/team/Mourad.jpeg"

export const teamMembers = [
    {
        name: "Mehrdad Rostami",
        image: mehrdadImg,
        affiliation: "University of Oulu, Finland",
        email: "mailto:mehrdad.rostami@oulu.fi",
    },
    {
        name: "Alexander Felfernig",
        image: alexImg,
        affiliation: "Graz University of Technology, Austria",
        email: "mailto:alexander.felfernig@tugraz.at",
    },
    {
        name: "Avishek Anand",
        image: avishekImg,
        affiliation: "Delft University of Technology (TU Delft), Netherlands",
        email: "mailto:avishek.anand@tudelft.nl",
    },
    {
        name: "Wolfgang Wörndl",
        image: wolfgangImg,
        affiliation: "Technical University of Munich, Germany",
        email: "mailto:woerndl@cit.tum.de",
    },
    {
        name: "Mourad Oussalah",
        image: mouradImg,
        affiliation: "University of Oulu, Finland",
        email: "mailto:mourad.oussalah@oulu.fi",
    },
    {
        name: "Mahdi Jalili",
        image: mahdiImg,
        affiliation: "RMIT University, Australia",
        email: "mailto:mahdi.jalili@rmit.edu.au",
    },
    {
        name: "Ashmi Banerjee",
        image: ashmiImg,
        affiliation: "Technical University of Munich, Germany",
        email: "mailto:ashmi.banerjee@tum.de",
    },
];
